import { Config, ConfigSchema } from './Config'

export { ConfigSchema }
export type { Config }

const isSameOriginPath = (value: string) => /^[a-zA-Z0-9._/-]*$/.test(value) && !value.includes('//')

/**
 * Builds a loader for the deployment's `runtime-config.json`.
 *
 * `pathPrefix` selects an alternative config folder within the same deployment
 * (used on previews and in dev) and must be a relative, same-origin path.
 */
export const getNewConfig = (pathPrefix: string) => async (): Promise<Config> => {
  if (!isSameOriginPath(pathPrefix)) {
    throw new Error('config path prefix must be a relative, same-origin path')
  }
  const resp = await fetch(`${pathPrefix}/runtime-config.json`)
  const config = await resp.json()
  return { ...ConfigSchema.parse(config), services: config.services_v2 }
}
